import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormHelperText from '@material-ui/core/FormHelperText/FormHelperText';
import FormControl from '@material-ui/core/FormControl/FormControl';
import Container from '../layout/Container';

const useStyles = makeStyles({
  container: {
    display: 'flex' as const,
    flexWrap: 'wrap' as const,
  },
  formControl: { marginBottom: 3 },
  formControlError: { marginBottom: 10 },
  typography: {
    fontSize: 11,
    padding: '0 0 4px 0',
    letterSpacing: -0.3,
  },
  FormHelperText: {
    display: 'none',
  },
  textField: { background: 'white' },
  display: {
    display: 'block',
    position: 'absolute',
    bottom: -15,
  },
  hide: {
    display: 'none',
  },
});

const FieldContainer: React.FC<any> = ({ children, errorText }) => {
  const classes = useStyles();
  return (
    <FormControl className={errorText ? classes.formControlError : classes.formControl} error fullWidth>
      {children}
      <Container className={errorText ? classes.display : classes.hide}>
        <FormHelperText
          id="component-error-text"
          classes={{
            root: classes.typography,
          }}
        >
          {React.isValidElement(errorText) ? { errorText } : null}
        </FormHelperText>
      </Container>
    </FormControl>
  );
};

export default FieldContainer;
